module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.0e28aac6.eot";